app.service('updateExcludedServices', function () {

	function run(options) {
        let $input = options.$input;
        let $inputs = options.$inputs;
        let productId = $input.data('product');
		let groupId = ''+$input.data('excluded-services-group');
        //console.log($input, $inputs, productId, groupId);
		if(groupId.length && $inputs.length){
			let $group = $inputs.filter('[data-product='+productId+']').filter('[data-excluded-services-group='+groupId+']').not($input);
			if($group.length){
				if($input.is(':checked')){
					$group.prop('checked', false);
				}
			}
		}
	}

	return {
		run
	};
});